import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_hdr_RowClass, bl_wf_issue_hdr_RowInterface} from '../../../dbschema/bl_wf_issue_hdr.model';
import {bl_wf_issue_line_RowClass} from '../../../dbschema/bl_wf_issue_line.model';
import {bl_wf_issue_ext_RowClass} from '../../../dbschema/bl_wf_issue_ext.model';
import {bl_wf_issue_event_RowClass} from '../../../dbschema/bl_wf_issue_event.model';

export class WfIssueContainerModel extends BaseContainerModel {
  issueHdr: bl_wf_issue_hdr_RowInterface = new bl_wf_issue_hdr_RowClass();
  issueLineList: bl_wf_issue_line_RowClass[] = [];
  issueExtList: bl_wf_issue_ext_RowClass[] = [];
  issueEventList: bl_wf_issue_event_RowClass[] = [];

}
